import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, reverse } from 'lodash';
import { round } from 'mathjs';

import moStore, { toggleValue } from '@store/index';
import EffectService from '@service/effect';
import { newRate } from '@tool/index';

const moTimeTrend = observable({
  type: 'chart', // chart, table
  empty: false,
  tableTitle: <any[]>[],
  tableList: <any[]>[],
  labels: <any[]>[],
  barData: <any[]>[],
  lineData: <any[]>[],
  overview: <any[]>[],
});

const timeTrendInit = action((res: any, loading = false) => {
  if (isEmpty(res) || isEmpty(res.data)) {
    moTimeTrend.empty = true;
    return;
  }
  moTimeTrend.empty = false;
  // console.log('人员设置 时间趋势 -- ', res);
  const barArr: any[] = [];
  const lineArr: any[] = [];
  const labelArr: any[] = [];
  const tableArr: any[] = [];

  res.data.map((item: any) => {
    barArr.push(item.value);
    lineArr.push(item.ratio);
    labelArr.push(item.year);
  });
  res.data.map((item: any) => {
    const tempArr: any[] = [];
    for (const key in item) {
      if (key === 'ratio') tempArr.push(newRate(item[key]));
      else if (key === 'value') tempArr.push(`${item[key]}人`);
      else tempArr.push(item[key]);
    }
    tableArr.push(tempArr);
  });

  runInAction(() => {
    moTimeTrend.labels = labelArr;
    moTimeTrend.barData = barArr;
    moTimeTrend.lineData = lineArr;
    moTimeTrend.overview = res.overview;
    moTimeTrend.tableTitle = ['年份', '人员规模', '变化率'];
    moTimeTrend.tableList = reverse(tableArr);
  });
});

const changeType = action((value: string) => {
  moTimeTrend.type = value;
  localStorage.setItem('settleTimeTrendType', value);
});

export default moTimeTrend;
export {
  timeTrendInit, changeType,
};
